import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

const previousDate = (date, days) =>
    moment(date)
        .subtract(days, "days")
        .format("YYYY-MM-DD");
const previousMonth = (date, months) =>
    moment(date, "YYYY-MM-DD")
        .subtract(months, "months")
        .format("YYYY-MM-DD");

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        rawData: null,
        options: {
            range: "6 Months",
            startDate: null,
            endDate: null,
            dateRange: null,
            city: "All Areas",
            callType: "All Categories",
        },
    },
    mutations: {
        initializeOptions(state, options) {
            state.options = options;
        },
        changeRange(state, newRange) {
            let newOptions = { ...state.options };
            newOptions.range = newRange;
            if (newRange === "Week") {
                newOptions.startDate = previousDate(newOptions.dateRange[1], 7);
                newOptions.endDate = newOptions.dateRange[1];
            } else if (newRange === "Month") {
                newOptions.startDate = previousMonth(
                    newOptions.dateRange[1],
                    1
                );
                newOptions.endDate = newOptions.dateRange[1];
            } else if (newRange === "2 Months") {
                newOptions.startDate = previousMonth(
                    newOptions.dateRange[1],
                    2
                );
                newOptions.endDate = newOptions.dateRange[1];
            } else if (newRange === "3 Months") {
                newOptions.startDate = previousMonth(
                    newOptions.dateRange[1],
                    3
                );
                newOptions.endDate = newOptions.dateRange[1];
            } else if (newRange === "6 Months") {
                newOptions.startDate = previousMonth(
                    newOptions.dateRange[1],
                    6
                );
                newOptions.endDate = newOptions.dateRange[1];
            } else if (newRange === "All Dates") {
                newOptions.startDate = newOptions.dateRange[0];
                newOptions.endDate = newOptions.dateRange[1];
            }
            state.options = newOptions;
        },
        changeOptions(state, e) {
            state.options[e.source] = e.value;
        },
        setData(state, data) {
            state.rawData = data;
        },
    },
});
